import { render, staticRenderFns } from "./OffineSync.vue?vue&type=template&id=571f3cb0&scoped=true"
import script from "./OffineSync.vue?vue&type=script&lang=ts"
export * from "./OffineSync.vue?vue&type=script&lang=ts"
import style0 from "./OffineSync.vue?vue&type=style&index=0&id=571f3cb0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571f3cb0",
  null
  
)

export default component.exports